import React, { useEffect, useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Login from "./app/Login";
import Sample from "./app/SamplePage";
import ApplyForCredit from "./app/ApplyForCredit";
import Home from "./app/Home";
import Header from "./components/Header";
import ConnectToYourbank from "./app/ConnectToYourbank";
import OTP from "./app/Login/section/OTP";
import CustomerPortal from "./app/CustomerPortal";
import useWindowDimensions from "./helpers/Hooks/useWindowDimensions";
import { routes } from "./helpers/Routes";
import Version from "./components/Version";
import { Toaster } from "react-hot-toast";

function App() {
  const location = useLocation();

  const [showHeader, setShowHeader] = useState(true);
  const { height, width } = useWindowDimensions();
  // console.log(location.pathname);

  return (
    // <div className={`App pb-2 h-screen`}>
    <div className={`relative App h-full`}>
      {/* {showHeader ? (
        <section className="sticky top-0">
          <Header />
        </section>
      ) : null} */}
      <Routes>
        <Route path={routes.home} element={<Home />} />
        <Route
          path={routes.login}
          element={<Login setShowHeader={setShowHeader} />}
        />
        <Route
          path={routes.otp}
          element={<OTP setShowHeader={setShowHeader} />}
        />
        <Route path="/sample" element={<Sample />} />
        <Route path={routes.apply} element={<ApplyForCredit />} />
        <Route path={routes.connectBank} element={<ConnectToYourbank />} />
        <Route path={routes.customerPortal} element={<CustomerPortal />} />
      </Routes>
      {/* {
        // location.pathname ===
        // routes.apply ? null : location.pathname ===
        //   routes.customerPortal
        location.pathname === "/" ? (
          <section className="absolute z-50 bottom-0 right-2">
            <Version />
          </section>
        ) : null
      } */}
      <Toaster
        toastOptions={{
          className: "text-sm",
          style: {
            borderRadius: "50px",
            //   backgroundColor: "#000",
          },
          custom: {
            duration: 10000,
            // theme: {
            //   primary: "green",
            //   secondary: "black",
            // },
          },
        }}
        position="top-center"
      />
    </div>
  );
}

export default App;
